import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { CardContentProps } from "./types";

export const CardContent = ({ className, testID, children }: CardContentProps) => (
  <Box
    className={cn("gap-spacing-sm flex flex-1 flex-col", className)}
    {...platformProps({ testID, slot: "card-content" })}
  >
    {children}
  </Box>
);

CardContent.displayName = "Card.Content";
